import React, { useState, useEffect } from "react";
import "../styles/TeacherDownloadPage.css";
import { useNavigate } from "react-router-dom";
import { getUserID } from "../Storage/Storage";
import {
  getLicenseKey,
  downloadCount,
  userProfile,
} from "../Services/AllServices";

import TeacherProfileNav from "./TeacherProfileNav";
import UserLogo from "./UserLogo";

const DownloadPage = () => {
  const [user, setUserProfileInfo] = useState({});
  const [licenseKey, setLicenseKey] = useState("");
  const [downloadProgress, setDownloadProgress] = useState(0);
  const [isDownloading, setIsDownloading] = useState(false);
  const navigate = useNavigate();

  const formatDate = (dateString) => {
    if (!dateString) return "NA";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB"); // Formats the date as dd/mm/yyyy
  };

  const updateDownloadCount = async () => {
    try {
      await downloadCount((response) => {
        // Replace with actual API call
        console.log("Download Check response: ", response);
        console.log("updated download count value:", response.downloadCount);
        if (response.status === "success") {
          console.log(
            "navigating to dashboard from Download ",
            response.downloadCount
          );
          navigate("/teacher");
        } else {
          console.log(" Download check updating to true failed ", response);
        }
      });
    } catch (error) {
      console.log(" Error updating the download status to true ", error);
    }
  };

  useEffect(() => {
    const fetchLicenseKey = async () => {
      try {
        const userId = await getUserID();
        const formData = { user_id: userId };

        await userProfile((response) => {
          if (response && response.status === "success") {
            setUserProfileInfo(response.data);
          } else {
            console.log(
              "Failed to load userProfile in teacher profile header",
              response
            );
          }
        });

        await getLicenseKey(formData, (response) => {
          if (response.status === "success") {
            setLicenseKey(response.data.licensekey);
          }
        });
      } catch (error) {
        console.log("Error fetching license key", error);
      }
    };

    fetchLicenseKey();
  }, [navigate]);

  // Handle Download and Progress Calculation
  // const handleDownload = async (e) => {
  //   e.preventDefault();
  //   setIsDownloading(true);
  //   setDownloadProgress(0); // Reset progress before starting a new download

  //   try {
  //     const response = await fetch(e.target.href);
  //     const contentLength = response.headers.get("content-length");

  //     if (!contentLength) {
  //       console.error("Content length not available");
  //       alert("Please try downloading again!");
  //       setIsDownloading(false);
  //       return;
  //     }

  //     const reader = response.body.getReader();
  //     let receivedLength = 0;
  //     const totalLength = parseInt(contentLength, 10);
  //     const chunks = [];

  //     while (true) {
  //       const { done, value } = await reader.read();
  //       if (done) break;
  //       chunks.push(value);
  //       receivedLength += value.length;
  //       setDownloadProgress((receivedLength / totalLength) * 100);
  //     }

  //     const blob = new Blob(chunks);
  //     const url = window.URL.createObjectURL(blob);
  //     const a = document.createElement("a");
  //     a.href = url;
  //     a.download = "AnaVu.exe";
  //     document.body.appendChild(a);
  //     a.click();
  //     a.remove();
  //     window.URL.revokeObjectURL(url);

  //     // Call the download count update after the download is complete
  //     await updateDownloadCount();

  //     // Ensure progress is shown as complete
  //     setIsDownloading(false);
  //     setDownloadProgress(100);
  //   } catch (error) {
  //     console.error("Download failed", error);
  //     setIsDownloading(false);
  //   }
  // };

  // Handle Download and Progress Calculation
  // const handleDownload = async (e, retryCount = 0) => {
  //   e.preventDefault();
  //   setIsDownloading(true);
  //   setDownloadProgress(0); // Reset progress before starting a new download

  //   try {
  //     const response = await fetch(e.target.href);
  //     const contentLength = response.headers.get("content-length");

  //     if (!contentLength) {
  //       console.log(licenseKey);
  //       console.error("Content length not available");
  //       if (retryCount < 15) {
  //         // Retry up to 3 times
  //         console.log(`Retrying download... attempt ${retryCount + 1}`);
  //         setTimeout(() => handleDownload(e, retryCount + 1), 500); // Wait 1 second before retrying
  //         return;
  //       } else {
  //         // If retries exceeded, stop the download process
  //         setIsDownloading(false);
  //         console.error("Failed to get content length after 15 attempts.");
  //         alert("Retry downloading again");
  //         return;
  //       }
  //     }

  //     const reader = response.body.getReader();
  //     let receivedLength = 0;
  //     const totalLength = parseInt(contentLength, 10);
  //     const chunks = [];

  //     while (true) {
  //       const { done, value } = await reader.read();
  //       if (done) break;
  //       chunks.push(value);
  //       receivedLength += value.length;
  //       setDownloadProgress((receivedLength / totalLength) * 100);
  //     }

  //     const blob = new Blob(chunks);
  //     const url = window.URL.createObjectURL(blob);
  //     const a = document.createElement("a");
  //     a.href = url;
  //     a.download = "AnaVu.exe";
  //     document.body.appendChild(a);
  //     a.click();
  //     a.remove();
  //     window.URL.revokeObjectURL(url);

  //     // Call the download count update after the download is complete
  //     await updateDownloadCount();

  //     // Ensure progress is shown as complete
  //     setIsDownloading(false);
  //     setDownloadProgress(100);
  //   } catch (error) {
  //     console.error("Download failed", error);
  //     setIsDownloading(false);
  //   }
  // };

  const handleDownload = async (e) => {
    e.preventDefault();
    setIsDownloading(true);
    setDownloadProgress(0); // Reset progress before starting a new download

    try {
      const response = await fetch(e.target.href);

      if (!response.ok) {
        throw new Error("Failed to fetch the file. Please try again.");
      }

      const contentLength = response.headers.get("content-length");
      if (!contentLength) {
        console.log(licenseKey);
        console.error(
          "Content-Length header is missing. Proceeding without it."
        );
      }

      const totalLength = contentLength ? parseInt(contentLength, 10) : null;
      const reader = response.body.getReader();
      let receivedLength = 0;
      const chunks = [];

      while (true) {
        const { done, value } = await reader.read();
        if (done) break;

        chunks.push(value);
        receivedLength += value.length;

        // Update progress if contentLength is available
        if (totalLength) {
          setDownloadProgress((receivedLength / totalLength) * 100);
        }
      }

      const blob = new Blob(chunks);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "AnaVuBuild.zip";
      // a.download = "AnaVu.exe";
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);

      console.log("Download completed successfully");

      // Update download count after successful completion
      await updateDownloadCount();

      setIsDownloading(false);
      setDownloadProgress(100); // Ensure progress is shown as complete
    } catch (error) {
      console.error("Download failed", error);
      setIsDownloading(false);
      alert("Download failed. Please try again.");
    }
  };

  return (
    <>
      <UserLogo />
      <TeacherProfileNav isDownloadPage={true} />
      <div className="teacher_download-section">
        <svg
          className="teacher_download-icon"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
          <polyline points="7 10 12 15 17 10"></polyline>
          <line x1="12" y1="15" x2="12" y2="3"></line>
        </svg>
        <h2>Download the AnaVu software to start creating!</h2>

        {isDownloading && (
          <div className="teacher-download-popup">
            <div className="teacher-download-popup-content">
              <h2>Download in Progress</h2>

              <div className="teacher-download-progress-bar">
                <div
                  className="teacher-download-progress-bar-fill"
                  style={{ width: `${downloadProgress}%` }}
                ></div>
              </div>
              <p>
                Please do not close this window until the download is complete.
              </p>
            </div>
          </div>
        )}

        <div className="teacher_download-license">
          License Key:&nbsp;{user.licensekey ? user.licensekey : "NA"}
        </div>

        <div className="teacher_download-license">
          Expiry Date: &nbsp;
          {user.licenseEndDate ? formatDate(user.licenseEndDate) : "NA"}{" "}
        </div>

        {/* <button className="teacher_download-button" onClick={handleDownload}>
          <a
            // href="https://tto-asset.s3.ap-south-1.amazonaws.com/Anavu/BuildFile/AnaVu.exe"
            href="https://tto-asset.s3.ap-south-1.amazonaws.com/Anavu/BuildFile/anavubuild.zip"
            download
            style={{
              textDecoration: "none",
              color: "#FFF",
              width: "100%",
              height: "100%",
            }}
          >
            Download AnaVu
          </a>
        </button> */}

        <button className="teacher_download-button" onClick={handleDownload}>
          <a
            href="https://tto-asset.s3.ap-south-1.amazonaws.com/Anavu/BuildFile/anavubuild.zip" // File URL
            download
            style={{
              textDecoration: "none",
              color: "#FFF",
              width: "100%",
              height: "100%",
            }}
          >
            Download AnaVu
          </a>
        </button>
      </div>
    </>
  );
};

export default DownloadPage;
